import { render, staticRenderFns } from "./NewMedDialog.vue?vue&type=template&id=6bcbc564&scoped=true&"
import script from "./NewMedDialog.vue?vue&type=script&lang=js&"
export * from "./NewMedDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewMedDialog.vue?vue&type=style&index=0&id=6bcbc564&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcbc564",
  null
  
)

export default component.exports